import {roleSystemRoute} from './route_utilities'
import GeneralPurposeDataTypes from '../../views/generalpurposedata/GeneralPurposeDataTypes.vue'


export const generalpurposedatatypes =  {
  path: 'generalpurposedatatypes',
  name: 'GeneralPurposeDataTypes',
  component: GeneralPurposeDataTypes,
  beforeEnter : roleSystemRoute,
  meta: {
      title: "genel_data_tipleri",
      domain:"generalpurposedatatypes",
      accessroles:["admin"],
    },
  }